<template>
  <div>
    <div class="content-box">
      <left-column :navList="navList" title="关于我们" :activeNav="activeNav" :getActive="getActive"/>
      <div class="content-right">
        <div class="join-company" v-if="activeNav==1">
          <h3>直接签约授权合作伙伴</h3>
          <div class="banner_partner">
            <ul>
              <li v-for="(item,index) in imgList" :key="index">
                <img :src="item.url" alt="">
              </li>
            </ul>
            <p>
              *排名不分前后，更多合作请持续关注
              <strong>胤之旅</strong>
            </p>
          </div>
        </div>
        <div v-html="contentText" v-if="activeNav==2||activeNav==3"></div>
        <div v-if="activeNav==0">
          <div class="main">
            <div class="main-banner">
              <div>
                <p>ENTERPRISE</p>
                <p>INTRODUCTION</p>
              </div>
            </div>
            <div class="main-content">
              <div class="container">
                <div class="container-top">
                  <img
                    src="//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/html/introduction/BANNER2.jpg?x-oss-process=style/webp"
                    alt=""
                  >
                  <div class="rigth">
                    <div class="right-logo">
                      <!-- <img src="./imager/logo.png" alt=""> -->
                    </div>
                    <p>胤之旅，品牌定位于“旅游供应链优质服务品牌”，隶属于广东胤之旅科技有限公司（以下简称“胤之旅”），以整合全球旅游产业资源和航空客运服务为价值依托，竭诚打造全球旅游供应链生态圈，致力于为组团社、地接社、景区、酒店、大小交通等旅游同业上下游提供一站式的旅游资源交易平台。</p>
                  </div>
                </div>
                <div class="container-introduce">
                  <p>胤之旅积极赋能旅行社，通过平台极具竞争力且多元化的旅游资源，满足旅行社发展不同阶段对于产品的不同需求。目前平台上游资源包括过百家航空公司，十万家境内外酒店，数千家旅行社，海内外业务边界不断扩大，为旅游同业提供机票代理、铁路代理、景点门票代理、酒店预订、旅游度假、签证服务、旅游保险等旅游供应链资源和服务，已整合成为一站式互联网旅游产品交易B2B服务平台。胤之旅平台同时也提供跨境电商、差旅管理（TMC）、会展旅游（MICE）、活动策划、研学定制等特殊旅游服务支持，助力合作旅行社在“降低运营成本，提高运转效率，增加经营收益”方面获得最大化经营成果，最终实现产业多方共赢。此外，胤之旅建设有自主知识产权的旅游供应链风控模型，为深度合作的旅行社建立“旅行社信用数据库”，为其提供账期赊销和垫支预付等增值服务，为旅行社提供一体化的管理服务，助力旅行社进一步加深业务竞争优势，让旅行社更轻松，让客户更满意，最终赢取更大的市场份额。</p>
                </div>
              </div>
              <div class="content-banner"></div>
              <div class="container">
                <div class="container-norm">
                  <div class="container-norm-left">
                    <p>ENTER</p>
                    <p>PRISE</p>
                    <p>VISION</p>
                  </div>
                  <div class="container-norm-right">
                    <p>胤之旅一直秉承“技术研发服务于产业需求”的平台开发理念，在为旅游同业研发实用高效和便捷拓展的产品功能上不遗余力，聘请了信息化行业国家级技术专家作为平台技术负责人，在旅游同业平台系统建设，网络信息安全与管控，数据分析等方面拥有深厚底蕴和丰富的技术积累，目前已经开发有：胤之旅酒店同业服务系统、胤之旅全球机票预订系统、胤之旅供应链风控模型系统、胤之旅同业营销套件系统等，全部系统均有自主知识产权，协助旅游同业通过更高效地使用信息化工具，开展内控管理和营销渠道建设，扩大经营成果。</p>
                  </div>
                </div>
                <p
                  class="container-norm-text"
                >“资源规模化，服务规范化，分销系统化”是胤之旅不断追求的经营目标，未来，胤之旅将会在各大城市布局网点，打破服务地域上的限制，全力整合产业上下游资源，建立更完善的旅游全域营销网络体系，坚持以客户为中心，致力打造服务更贴心，价格更透明，产品更多元化，功能更人性化的在线旅游B2B交易平台，为旅行社提供更优质的服务，成为旅游同业的首选合作伙伴，最终实现胤之旅成为全球知名旅游供应链优质服务品牌的企业愿景。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import knowledge from "./text/knowledge";
import liability from "./text/liability";
import LeftColumn from "../components/leftColumn";

export default {
  data() {
    return {
      contentText: null,
      activeNav: null,
      navList: ["胤之旅简介", "合作伙伴", "网站声明", "知识产权声明"],
      imgList: [
        // { url: require("../components/img/partner/sc1 (1).png") },
        // { url: require("../components/img/partner/sc1 (2).png") },
        // { url: require("../components/img/partner/sc1 (3).png") },
        // { url: require("../components/img/partner/sc1 (4).png") },
        // { url: require("../components/img/partner/sc1 (5).png") },
        // { url: require("../components/img/partner/sc1 (6).png") },
        // { url: require("../components/img/partner/sc1 (7).png") },
        // { url: require("../components/img/partner/sc1 (8).png") },
        // { url: require("../components/img/partner/sc1 (9).png") },
        // { url: require("../components/img/partner/sc1 (10).png") },
        // { url: require("../components/img/partner/sc1 (11).png") },
        // { url: require("../components/img/partner/sc1 (12).png") },
        // { url: require("../components/img/partner/sc1 (13).png") },
        // { url: require("../components/img/partner/sc1 (14).png") },
        // { url: require("../components/img/partner/sc1 (15).png") },
        // { url: require("../components/img/partner/sc1 (16).png") },
        // { url: require("../components/img/partner/sc1 (17).png") },
        // { url: require("../components/img/partner/sc1 (18).png") },
        // { url: require("../components/img/partner/sc1 (19).png") },
        // { url: require("../components/img/partner/sc1 (20).png") },
        // { url: require("../components/img/partner/sc1 (21).png") },
        // { url: require("../components/img/partner/sc1 (22).png") },
        // { url: require("../components/img/partner/sc1 (23).png") },
        // { url: require("../components/img/partner/sc1 (24).png") },
        // { url: require("../components/img/partner/sc1 (25).png") },
        // { url: require("../components/img/partner/sc1 (26).png") },
        // { url: require("../components/img/partner/sc1 (27).png") },
        // { url: require("../components/img/partner/sc1 (28).png") },
        // { url: require("../components/img/partner/sc1 (29).png") },
        // { url: require("../components/img/partner/sc1 (30).png") },
        // { url: require("../components/img/partner/sc1 (31).png") },
        // { url: require("../components/img/partner/sc1 (32).png") },
        // { url: require("../components/img/partner/sc1 (33).png") },
        // { url: require("../components/img/partner/sc1 (34).png") },
        // { url: require("../components/img/partner/sc1 (35).png") },
        // { url: require("../components/img/partner/sc1 (36).png") },
        // { url: require("../components/img/partner/sc1 (37).png") },
        // { url: require("../components/img/partner/sc1 (38).png") },
        // { url: require("../components/img/partner/sc1 (39).png") },
        // { url: require("../components/img/partner/sc1 (40).png") },
        // { url: require("../components/img/partner/sc1 (41).png") },
        // { url: require("../components/img/partner/sc1 (42).png") },
        // { url: require("../components/img/partner/sc1 (43).png") },
        // { url: require("../components/img/partner/sc1 (44).png") },
        // { url: require("../components/img/partner/sc1 (45).png") },
        // { url: require("../components/img/partner/sc1 (46).png") },
        // { url: require("../components/img/partner/sc1 (47).png") },
        // { url: require("../components/img/partner/sc1 (48).png") },
        // { url: require("../components/img/partner/sc1 (49).png") },
        // { url: require("../components/img/partner/sc1 (50).png") }
        // { url: require("../components/img/partner/sc1 (51).png") }
      ]
    };
  },
  components: { LeftColumn },

  methods: {
    getActive(val) {
      this.activeNav = val;
      val == 2
        ? (this.contentText = liability)
        : val == 3
          ? (this.contentText = knowledge)
          : "";
    }
  },
  created() {
    this.activeNav = this.$route.query.type || 0;
    this.getActive(this.activeNav);
  }
};
</script>
<style lang="less" scoped>
.content-box {
  width: 1200px;
  margin: auto;
  margin-top: 20px;
  display: flex;
  .content-left {
    width: 238px;
    h2 {
      padding: 20px 0 15px 10px;
      font-size: 20px;
      color: #237dc8;
    }
    .content-left_text {
      font-size: 14px;
      color: #666;
      p:nth-child(1) {
        border-top: 1px solid #dfdfdf;
      }
      p {
        padding: 10px 0;
        border-bottom: 1px solid #dfdfdf;
        cursor: pointer;
        &:hover {
          color: #237dc8;
        }
      }
      i {
        color: #237dc8;
      }
    }
  }
  .content-right {
    width: 80%;
    margin: 20px 0 0 51px;
    // border: 1px solid #dfdfdf;
  }
  .join-company {
    h3 {
      color: #333333;
      font: Bold Microsoft YaHei;
      font-size: 17px;
    }
  }
}
.banner_partner {
  margin-top: 20px;
  p {
    color: #333;
    font-size: 13px;
    text-align: right;
    padding: 50px 73px 0 0;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      padding-right: 3px;
      width: 115px;
      // border: 1px dashed #237dc9;
      margin: 0 0 5px 5px;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
      }
      &:last-child {
        padding: 0;
      }
    }
  }
}
</style>
<style>
.main .main-banner {
  width: 100%;
  height: 380px;
  background: url("//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/html/introduction/BANNER1.jpg?x-oss-process=style/webp")
    no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
}

.main-banner > div {
  /* width: 1178px; */
}

.main .main-banner p {
  font-size: 80px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  color: #f7f7f7;
  opacity: 0.25;
  /* text-align: left; */
}

.main-content {
  font-size: 15px;
}

.main-content .container {
  /* width: 1178px; */
  margin: auto;
  color: #3a3a3a;
}

.container .container-top {
  transform: translateY(-50px);
  height: 460px;
  font-size: 18px;
  background: white;
  color: #333;
  display: flex;
  box-shadow: 0px -10px 30px 0px rgba(0, 0, 0, 0.2);
}

.container .container-top img {
  width: 50%;
}

.container .container-top .rigth {
  padding: 60px;
}

.container .container-top .rigth p {
  line-height: 28px;
  font-size: 14px;
}

.container .container-top .rigth .right-logo {
  text-align: center;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #dcdcdc;
  margin-bottom: 25px;
  position: relative;
}

.container .container-top .rigth .right-logo img {
  width: auto;
  height: 55px;
}

.container .container-top .rigth .right-logo::after {
  content: "";
  display: block;
  width: 100px;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  background: #b5d4ed;
}

.content-banner {
  height: 429px;
  background: url("//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/html/introduction/BANNER3.jpg?x-oss-process=style/webp");
}

.container-introduce {
  border-left: 3px solid #99bede;
  padding: 0 50px;
  line-height: 28px;
  font-size: 14px;
  text-align: justify;
  letter-spacing: 1px;
  margin: 21px 0 117px 0;
}

.container-norm {
  display: flex;
  justify-content: center;
  margin-bottom: 70px;
}

.container-norm-left {
  font-size: 80px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 3px;
  color: #20468a;
  opacity: 0.28;
  margin-right: 50px;
}

.container-norm-left > p {
  text-shadow: 0 0 10px #333;
}

.container-norm-right {
  width: 40%;
  color: white;
  position: relative;
}

.container-norm-right p {
  position: absolute;
  bottom: 0;
  background: #014c8f;
  padding: 82px 57px;
  font-size: 14px;
  line-height: 28px;
  text-align: justify;
  box-shadow: 0px -10px 30px 0px rgba(0, 0, 0, 0.2);
}

.container-norm-text {
  text-align: justify;
  letter-spacing: 1px;
  line-height: 25px;
  padding: 50px 100px;
  font-size: 14px;
}
</style>
